<template>
    <div class="page px-4">
        <div v-if="isLoaded">
            <div>
                <img class="rounded-lg" :src="imgPromocode" alt=""/>
            </div>
            <div class="bg-white rounded-xl px-6 py-4 mt-5">
                <div class="text-center font-bold text-20 text-blue-1 pb-6">กิจกรรมกรอกปั๊ปรับคะแนนเลย<br>กรุณากรอกโค้ดเพื่อรับคะแนน</div>
                <div class="flex justify-center relative">
                    <div>
                        <InputText
                            class="promocode-input"
                            ref="form-promocode"
                            v-model:inputValue="lblInputCode"
                            :errorInfo="formErrorInfo[0]"
                            :inputLbl="fromLbl"
                            :maxLength="12"
                            :isUpperCase="true"
                            @update:inputValue="validateCode($event)">
                        </InputText>
                    </div>
                    <div class="absolute flex right-1 w-10" v-show="isShowValidate">
                        <img v-if="correct" src="../../../assets/icon/ic-correct.png" alt=""/>
                        <img v-else src="../../../assets/icon/ic-wrong.png" alt=""/>
                    </div>
                </div>
                <div class="border-t pt-4">
                    <button class="w-full rounded-full py-2.5 bg-green-1 text-white text-22" @click="clickGetPromocode()">รับคะแนน</button>
                </div>
            </div>
        </div>
    </div>
    <ModalMaster :controller="modalController"></ModalMaster>
</template>

<script>
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
import ConfigManager from '@/config/ConfigManager';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import promocode from '../service/promocode';
//helper
import { FormHelper } from '@/helper/FormHelper.js';
//component
import InputText from '@/components/Input/label/InputText.vue';
export default {
    name: 'promocode',
    mixins: [ ModalMixin, AuthStatusMixin, LocaleMixin ],
    components: {
        InputText
    },
    data: function() {
        return {
            imgPromocode: "",
            isValidate: false,

            lblInputCode: '',
            formErrorInfo: [],
            fromLbl: {},
            isShowValidate: false,
            correct: false,
            isLoaded: false,
        };
    },
    created: function() {
        this.imgPromocode = this.getImg();
        this.initFrom();
        this.isLoaded = true;
    },
    methods: {
        getImg: function() {
            return ConfigManager.getBlobUrl() + "/config/splus/images/promocode.jpg";
        },
        clickGetPromocode: function() {
            if (!this.isLogin) return this.checkLoginPopup();
            this.isValidate = false;
            let code = this.lblInputCode;
                code = code.toUpperCase()
            this.validateErr(code);
            this.sendPromocode(code);
            // this.promocodeModal
            //     .setTitle('กรุณากรอกโค้ดเพื่อรับคะแนน')
            //     .setBtnOk('ร่วมกิจกรรม')
            //     .show()
            // this.promocodeModal.onClickOk((code) => {
            //     let text = code;
            //     code = text.toUpperCase();
            //     console.log(code)
            //     this.validateErr(code);
            //     this.sendPromocode(code);
            // })
        },
        sendPromocode: function(code) {
            if (!this.isValidate) return ;
            let params = {};
                params.code = code;
                params.device_app_id = ConfigManager.getAppId();
            return new Promise((resolve) => {
                promocode.postPromocode(params).subscribe({
                    next: (data) => {
                        console.log(data)
                        this.promocodeSuccessModal
                                .setTitle('ยินดีด้วย')
                                .setMsg('คุณได้รับรางวัล' + ' ' + data.earn_points + ' ' + 'คะแนน')
                                .setBtnOk('ตกลง')
                                .show()
                        this.promocodeSuccessModal.onClickOk(() => {
                            this.AccountStore.methods.getProfile();
                            this.resetValidate();
                        });
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        if (err.id == 404 && this.isValidate) {
                            this.alertModal
                            .setMsg('กรุณาระบุโค้ดที่ถูกต้อง กรณีกรอกโค้ดถูกต้องแล้ว โค้ดของท่านอาจหมดอายุ หรือมีผู้ใช้โค้ดนี้ครบตามสิทธิ์ที่กำหนดแล้ว')
                            .show()
                        } else if (err.code == 409 && err.id == 2133) {
                            this.alertModal
                            .setMsg('ขออภัยโค้ดนี้ถูกใช้งานไปแล้ว กรุณากรอกโค้ดใหม่')
                            .show()
                        }  else if (err.code == 409 && err.id == 2134) {
                            this.alertModal
                            .setMsg('กรุณาระบุโค้ดที่ถูกต้อง กรณีกรอกโค้ดถูกต้องแล้ว โค้ดของท่านอาจหมดอายุ หรือมีผู้ใช้โค้ดนี้ครบตามสิทธิ์ที่กำหนดแล้ว')
                            .show()
                        } else if (err.id == 400) {
                            this.alertModal
                            .setMsg('กรุณาระบุโค้ดที่ถูกต้อง กรณีกรอกโค้ดถูกต้องแล้ว โค้ดของท่านอาจหมดอายุ หรือมีผู้ใช้โค้ดนี้ครบตามสิทธิ์ที่กำหนดแล้ว')
                            .show()
                        } else {
                            this.alertModal
                            .setMsg(err.message)
                            .show()
                        }
                        this.resetValidate();
                        resolve(false);
                    }
                });
            });
        },
        validateErr: function(code) {
            let prefix = code.substring(0, 3).toLowerCase()
                if(prefix == "sps") {
                    this.isValidate = false;
                    this.alertModal
                        .setMsg("โปรโมชั่นโค้ดไม่ถูกต้อง กรุณากรอกโค้ดนี้ที่กิจกรรม เพื่อนแนะนำเพื่อน เพื่อรับคะแนน")
                        .show()
                    return ;
                }
                if (prefix == "rew") {
                    this.isValidate = false;
                    this.alertModal
                        .setMsg("โปรโมชั่นโค้ดไม่ถูกต้อง กรุณากรอกโค้ดนี้เพื่อรับส่วนลดที่เมนูสิทธิพิเศษ")
                        .show()
                    return ;
                }
                if(prefix == 'pmc') {
                    this.isValidate = true;
                    return ;
                }
            let prefix1 = code.substring(0, 1).toLowerCase();
                if (prefix1 != 'p') {
                    this.isValidate = false;
                    this.alertModal
                        .setMsg("กรุณาระบุโค้ดที่ถูกต้อง")
                        .show()
                    return ;
                } else {
                    return this.isValidate = true;
                }
        },
        initFrom: function () {
            this.initialPromocode();
            this.formErrorInfo = FormHelper.genErrorInfo(1);
            let lbl = {
                    name: '',
                    placeholder: 'โค้ดรับคะแนน',
                    required: '',
                    too_short: '',
                    invalid: '',
                };
            this.fromLbl = lbl;
        },
        validateCode: function(code) {
            this.isShowValidate = true;
            this.correct = false;
            if (!code) {
                this.isShowValidate = false;
                return
            }
            if (code.length >= 7 && code.length <= 12) {
                let prefix = code.substring(0, 3).toLowerCase()
                if(prefix == 'pmc') {
                    this.correct = true;
                    return ;
                }
                let prefix1 = code.substring(0, 1).toLowerCase();
                    if (prefix1 == 'p') {
                        return this.correct = true;
                    }
            }
        },
        resetValidate: function() {
            this.isValidate = false;
            this.lblInputCode = "";
            this.$refs['form-promocode'].clearText();
            this.isShowValidate = false;
            this.correct = false;
        }
    }
}
</script>
<style lang="scss" scoped>
    .promocode-input {
        max-width: 200px;
        input {
            text-align: center;
        }
        ::placeholder {
            text-align: center;
        }
    }
</style>
